import { apiClient } from "../api/apiClient";
import { AdvertisementBannerRequest, AdvertisementBannerResponse, ApiResponse } from "../interfaces/AdvertisementBanner";



export const advertisementBannerService = {

  // ======================================
  // GET ALL
  // ======================================

 // ======================================
// GET ALL
// ======================================

getAll: async (): Promise<AdvertisementBannerResponse[]> => {

  const response = await apiClient.get<
    ApiResponse<AdvertisementBannerResponse[]>
  >("/AdvertisementBanner/GetAll");

  const result = response.data;

  console.log(
    "Advertisement Banner API:",
    result
  );

  if (!result.isSuccess) {

    throw new Error(
      result.message
    );
  }

  // FIX HERE

  return result.dataList || [];
},

  // ======================================
  // GET BY ID
  // ======================================

  getById: async (
    bannerID: number
  ): Promise<AdvertisementBannerResponse> => {

    const response = await apiClient.get<
      ApiResponse<AdvertisementBannerResponse>
    >(
      `/AdvertisementBanner/GetById/${bannerID}`
    );

    const result = response.data;

    if (!result.isSuccess) {
      throw new Error(result.message);
    }

    return result.data!;
  },

  // ======================================
  // CREATE
  // ======================================

  create: async (
    payload: AdvertisementBannerRequest
  ) => {

    const formData = new FormData();

    formData.append(
      "title",
      payload.title
    );

    formData.append(
      "offerText",
      payload.offerText || ""
    );

    formData.append(
      "subText",
      payload.subText || ""
    );

    formData.append(
      "ctaLabel",
      payload.ctaLabel || ""
    );

    formData.append(
      "ctaLink",
      payload.ctaLink || ""
    );

    formData.append(
      "textPosition",
      payload.textPosition
    );

    formData.append(
      "overlayOpacity",
      payload.overlayOpacity.toString()
    );

    formData.append(
      "textColor",
      payload.textColor
    );

    formData.append(
      "status",
      payload.status
    );

    formData.append(
      "sortOrder",
      payload.sortOrder.toString()
    );

    formData.append(
      "placement",
      payload.placement
    );

    if (payload.imageFile) {
      formData.append(
        "ImageFile",
        payload.imageFile
      );
    }

    const response = await apiClient.post<
      ApiResponse<AdvertisementBannerResponse>
    >(
      "/AdvertisementBanner/Create",
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    const result = response.data;

    if (!result.isSuccess) {
      throw new Error(result.message);
    }

    return result;
  },

  // ======================================
  // UPDATE
  // ======================================

  update: async (
    bannerID: number,
    payload: AdvertisementBannerRequest
  ) => {

    const formData = new FormData();

    formData.append(
      "title",
      payload.title
    );

    formData.append(
      "offerText",
      payload.offerText || ""
    );

    formData.append(
      "subText",
      payload.subText || ""
    );

    formData.append(
      "ctaLabel",
      payload.ctaLabel || ""
    );

    formData.append(
      "ctaLink",
      payload.ctaLink || ""
    );

    formData.append(
      "textPosition",
      payload.textPosition
    );

    formData.append(
      "overlayOpacity",
      payload.overlayOpacity.toString()
    );

    formData.append(
      "textColor",
      payload.textColor
    );

    formData.append(
      "status",
      payload.status
    );

    formData.append(
      "sortOrder",
      payload.sortOrder.toString()
    );

    formData.append(
      "placement",
      payload.placement
    );

    if (payload.imageFile) {
      formData.append(
        "ImageFile",
        payload.imageFile
      );
    }

    const response = await apiClient.put<
      ApiResponse<AdvertisementBannerResponse>
    >(
      `/AdvertisementBanner/Update/${bannerID}`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    const result = response.data;

    if (!result.isSuccess) {
      throw new Error(result.message);
    }

    return result;
  },

  // ======================================
  // DELETE
  // ======================================

  delete: async (
    bannerID: number
  ) => {

    const response = await apiClient.delete(
      `/AdvertisementBanner/Delete/${bannerID}`
    );

    return response.data;
  }
};